import React from "react";
import "./sessionCall.scss";
import { NavLink } from "react-router-dom";
const SessionCall = () => {
  return (
    <div className="bg-transparent">
      <div className=" max-w-[100rem] py-12 lg:py-16">
        <div className="lg:grid lg:grid-cols-2 lg:items-center lg:gap-8">
          <div className="flex flex-col justify-between">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl md:text-5xl lg:text-6xl font-stylish">
              What We Offer
            </h2>
            <p className="mt-3 max-w-3xl md:text-lg lg:text-xl text-gray-800">
              we strongly believe that practical learning experiences are key to
              success in the world of technology. That's why we offer a platform
              that connects individuals with the resources they need to build
              real-world projects and develop in-demand tech skills.
            </p>
            <div className="mt-8 sm:flex">
              <div className="rounded-md">
                <NavLink
                  to="/profile-forms"
                  className="no-underline flex items-center justify-center  border border-transparent text-black px-5 py-3 text-base font-medium hover:bg-gray-900 hover:text-white rounded-full"
                  style={{
                    backgroundColor: "#f4b563",
                  }}
                >
                  Schedule Session
                </NavLink>
              </div>
            </div>
          </div>
          <div className="mt-8 grid grid-cols-2 gap-0.5 md:grid-cols-3 lg:mt-0 lg:grid-cols-2">
            <div className="col-span-1 flex bg-gray-50 py-8 px-8 flex-col justify-center items-center icons ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clipPath="url(#clip0_1055_6125)">
                  <path
                    d="M18.8335 5H4.8335C2.62436 5 0.833496 6.79086 0.833496 9V23C0.833496 25.2091 2.62436 27 4.8335 27H18.8335C21.0426 27 22.8335 25.2091 22.8335 23V9C22.8335 6.79086 21.0426 5 18.8335 5Z"
                    fill="#252c33"
                  />
                  <path
                    d="M31.5761 7.57157L31.5757 7.57176L25.3335 11.3171V20.6829L31.5757 24.4283L31.576 24.4284C31.6519 24.474 31.7385 24.4986 31.8269 24.4998C31.9154 24.5009 32.0026 24.4786 32.0797 24.435C32.1567 24.3914 32.2208 24.3282 32.2654 24.2518C32.31 24.1754 32.3335 24.0885 32.3335 24L31.5761 7.57157ZM31.5761 7.57157C31.652 7.52595 31.7386 7.50131 31.8272 7.50016C31.9157 7.49902 32.003 7.52142 32.0801 7.56507M31.5761 7.57157L32.0801 7.56507M32.0801 7.56507C32.157 7.60867 32.221 7.6719 32.2655 7.74829C32.31 7.82471 32.3335 7.91157 32.3335 8.00001C32.3335 8.00002 32.3335 8.00002 32.3335 8.00003M32.0801 7.56507L32.3335 8.00003M32.3335 8.00003V23.9999V8.00003Z"
                    fill="#252c33"
                    stroke="#252c33"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1055_6125">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.833496)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <h6 className="text-sm sm:text-md mt-2">Practical Learning</h6>
            </div>
            <div className="col-span-1 flex bg-gray-50 py-8 px-8 flex-col justify-center items-center icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <path
                  d="M28.8335 6H4.8335C4.8335 5.46957 5.04421 4.96086 5.41928 4.58579C5.79436 4.21071 6.30306 4 6.8335 4H26.8335C27.3639 4 27.8726 4.21071 28.2477 4.58579C28.6228 4.96086 28.8335 5.46957 28.8335 6Z"
                  fill="#BDB4FE"
                />
                <path
                  d="M25.8335 2H7.8335C7.8335 1.46957 8.04421 0.960859 8.41928 0.585786C8.79436 0.210714 9.30306 0 9.8335 0L23.8335 0C24.3639 0 24.8726 0.210714 25.2477 0.585786C25.6228 0.960859 25.8335 1.46957 25.8335 2Z"
                  fill="#BDB4FE"
                />
                <path
                  d="M29.8335 8H3.8335C3.30306 8 2.79436 8.21071 2.41928 8.58579C2.04421 8.96086 1.8335 9.46957 1.8335 10V28C1.8335 28.5304 2.04421 29.0391 2.41928 29.4142C2.79436 29.7893 3.30306 30 3.8335 30H29.8335C30.3639 30 30.8726 29.7893 31.2477 29.4142C31.6228 29.0391 31.8335 28.5304 31.8335 28V10C31.8335 9.46957 31.6228 8.96086 31.2477 8.58579C30.8726 8.21071 30.3639 8 29.8335 8ZM13.8335 24V14L21.8335 19L13.8335 24Z"
                  fill="#252c33"
                />
              </svg>
              <h6 className="text-sm sm:text-md mt-2">Resource Library</h6>
            </div>
            <div className="col-span-1 flex bg-gray-50 py-8 px-8 flex-col justify-center items-center icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clipPath="url(#clip0_1055_4659)">
                  <path
                    d="M16.5 8C18.7091 8 20.5 6.20914 20.5 4C20.5 1.79086 18.7091 0 16.5 0C14.2909 0 12.5 1.79086 12.5 4C12.5 6.20914 14.2909 8 16.5 8Z"
                    fill="#BDB4FE"
                  />
                  <path
                    d="M4.5 13C6.70914 13 8.5 11.2091 8.5 9C8.5 6.79086 6.70914 5 4.5 5C2.29086 5 0.5 6.79086 0.5 9C0.5 11.2091 2.29086 13 4.5 13Z"
                    fill="#BDB4FE"
                  />
                  <path
                    d="M28.5 13C30.7091 13 32.5 11.2091 32.5 9C32.5 6.79086 30.7091 5 28.5 5C26.2909 5 24.5 6.79086 24.5 9C24.5 11.2091 26.2909 13 28.5 13Z"
                    fill="#BDB4FE"
                  />
                  <path
                    d="M16.5 23C19.8137 23 22.5 20.3137 22.5 17C22.5 13.6863 19.8137 11 16.5 11C13.1863 11 10.5 13.6863 10.5 17C10.5 20.3137 13.1863 23 16.5 23Z"
                    fill="#252c33"
                  />
                  <path
                    d="M23.175 25.4C18.958 24.869 14.042 24.869 9.825 25.4C7.343 25.713 5.5 27.857 5.5 30.358V30.752C5.5 31.555 5.948 32 6.5 32H26.5C27.052 32 27.5 31.555 27.5 31.003C27.5 30.545 27.5 30.969 27.5 30.358C27.5 27.857 25.657 25.713 23.175 25.4Z"
                    fill="#252c33"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1055_4659">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <h6 className="text-sm sm:text-md mt-2">Community Networking</h6>
            </div>
            <div className="col-span-1 flex bg-gray-50 py-8 px-8 flex-col justify-center items-center icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clipPath="url(#clip0_1055_6116)">
                  <path
                    d="M28.667 21C28.667 22.933 27.1 24.5 25.167 24.5C23.234 24.5 21.667 22.933 21.667 21C21.667 19.067 23.234 17.5 25.167 17.5C27.1 17.5 28.667 19.067 28.667 21Z"
                    fill="#252c33"
                    stroke="#252c33"
                  />
                  <path
                    d="M10.667 21C10.667 22.933 9.09999 24.5 7.16699 24.5C5.234 24.5 3.66699 22.933 3.66699 21C3.66699 19.067 5.234 17.5 7.16699 17.5C9.09999 17.5 10.667 19.067 10.667 21Z"
                    fill="#252c33"
                    stroke="#252c33"
                  />
                  <path
                    d="M23.167 13.018C23.167 11.961 22.602 10.97 21.693 10.433C20.589 9.779 18.734 9 16.167 9C13.566 9 11.72 9.777 10.629 10.429C9.72799 10.967 9.16699 11.955 9.16699 13.007V15H23.167V13.018Z"
                    fill="#252c33"
                  />
                  <path
                    d="M12.693 27.433C11.589 26.779 9.73399 26 7.16699 26C4.56599 26 2.71999 26.777 1.62899 27.429C0.727992 27.967 0.166992 28.955 0.166992 30.007V32H14.167V30.018C14.167 28.96 13.602 27.97 12.693 27.433Z"
                    fill="#252c33"
                  />
                  <path
                    d="M30.693 27.433C29.589 26.779 27.734 26 25.167 26C22.566 26 20.72 26.777 19.629 27.429C18.728 27.967 18.167 28.955 18.167 30.007V32H32.167V30.018C32.167 28.96 31.602 27.97 30.693 27.433Z"
                    fill="#252c33"
                  />
                  <path
                    d="M16.167 8C18.3761 8 20.167 6.20914 20.167 4C20.167 1.79086 18.3761 0 16.167 0C13.9579 0 12.167 1.79086 12.167 4C12.167 6.20914 13.9579 8 16.167 8Z"
                    fill="#252c33"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1055_6116">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.166992)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <h6 className="text-sm sm:text-md mt-2">Mentor Match Making</h6>
            </div>
            <div className="col-span-1 flex bg-gray-50 py-8 px-8 flex-col justify-center items-center icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clipPath="url(#clip0_901_9838)">
                  <path
                    d="M6.6665 7C8.5995 7 10.1665 5.433 10.1665 3.5C10.1665 1.567 8.5995 0 6.6665 0C4.73351 0 3.1665 1.567 3.1665 3.5C3.1665 5.433 4.73351 7 6.6665 7Z"
                    fill="#252c33"
                  />
                  <path
                    d="M5.1665 21.5H4.69088L4.66713 21.975L4.19088 31.5H2.6665V10.5C2.6665 9.96957 2.87722 9.46086 3.25229 9.08579C3.62736 8.71071 4.13607 8.5 4.6665 8.5H20.6665V10.0222L10.1438 10.5005L9.6665 10.5222V11V31.5H8.14213L7.66588 21.975L7.64213 21.5H7.1665H5.1665Z"
                    fill="#252c33"
                    stroke="#252c33"
                  />
                  <path
                    d="M29.1665 3H12.1665V5H28.1665V21H12.1665V23H21.5785L26.2925 31.485C26.3539 31.6039 26.4386 31.7093 26.5415 31.7949C26.6443 31.8805 26.7634 31.9446 26.8915 31.9834C27.0196 32.0221 27.1542 32.0348 27.2873 32.0206C27.4204 32.0063 27.5492 31.9656 27.6663 31.9006C27.7833 31.8357 27.8861 31.7479 27.9686 31.6425C28.0511 31.5371 28.1116 31.4162 28.1465 31.287C28.1814 31.1577 28.19 31.0228 28.1718 30.8902C28.1536 30.7576 28.1089 30.63 28.0405 30.515L23.8665 23H29.1665C29.4317 23 29.6861 22.8946 29.8736 22.7071C30.0611 22.5196 30.1665 22.2652 30.1665 22V4C30.1665 3.73478 30.0611 3.48043 29.8736 3.29289C29.6861 3.10536 29.4317 3 29.1665 3Z"
                    fill="#252c33"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_901_9838">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.166504)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <h6 className="text-sm sm:text-md mt-2">Accountability Coach</h6>
            </div>
            <div className="col-span-1 flex bg-gray-50 py-8 px-8 flex-col justify-center items-center icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clipPath="url(#clip0_901_9842)">
                  <path
                    d="M17.8335 15C18.9381 15 19.8335 14.1046 19.8335 13C19.8335 11.8954 18.9381 11 17.8335 11C16.7289 11 15.8335 11.8954 15.8335 13C15.8335 14.1046 16.7289 15 17.8335 15Z"
                    fill="#252c33"
                  />
                  <path
                    d="M17.1795 0.016019C13.805 0.246349 10.6464 1.75855 8.35093 4.24271C6.05549 6.72687 4.79703 9.99488 4.83348 13.377V13.783L2.42348 19.083C2.32203 19.3071 2.30673 19.5608 2.38053 19.7954C2.45432 20.0301 2.61202 20.2293 2.82348 20.355L4.83348 21.566V25C4.83348 26.0609 5.2549 27.0783 6.00505 27.8284C6.7552 28.5786 7.77261 29 8.83348 29H12.8335V32H26.8335V22.362C28.7454 20.5289 30.0512 18.1549 30.5757 15.5586C31.1001 12.9622 30.8182 10.2676 29.7677 7.83599C28.7172 5.40442 26.9483 3.35216 24.6984 1.95443C22.4484 0.556707 19.8248 -0.119665 17.1795 0.016019ZM24.8335 13.5C24.8344 13.6226 24.7903 13.7412 24.7096 13.8333C24.6289 13.9255 24.5171 13.9848 24.3955 14L22.6685 14.216C22.5489 14.6905 22.3599 15.1448 22.1075 15.564L23.1785 16.94C23.2532 17.0362 23.2902 17.1563 23.2827 17.2778C23.2751 17.3993 23.2235 17.5139 23.1375 17.6L22.4335 18.3C22.387 18.3464 22.3317 18.3832 22.271 18.4083C22.2103 18.4333 22.1452 18.4461 22.0795 18.446C21.9687 18.4459 21.861 18.409 21.7735 18.341L20.3935 17.274C19.9743 17.5264 19.52 17.7155 19.0455 17.835L18.8335 19.562C18.8183 19.6836 18.759 19.7954 18.6668 19.8761C18.5746 19.9569 18.456 20.001 18.3335 20H17.3335C17.2109 20.001 17.0923 19.9569 17.0002 19.8761C16.908 19.7954 16.8487 19.6836 16.8335 19.562L16.6175 17.835C16.1429 17.7155 15.6887 17.5264 15.2695 17.274L13.8935 18.345C13.8059 18.413 13.6983 18.4499 13.5875 18.45C13.5215 18.4496 13.4562 18.4361 13.3955 18.4104C13.3347 18.3847 13.2797 18.3471 13.2335 18.3L12.5335 17.6C12.4475 17.5139 12.3958 17.3993 12.3883 17.2778C12.3807 17.1563 12.4178 17.0362 12.4925 16.94L13.5635 15.564C13.3111 15.1448 13.122 14.6905 13.0025 14.216L11.2715 14C11.1499 13.9848 11.0381 13.9255 10.9574 13.8333C10.8766 13.7412 10.8325 13.6226 10.8335 13.5V12.5C10.8325 12.3775 10.8766 12.2589 10.9574 12.1667C11.0381 12.0745 11.1499 12.0152 11.2715 12L12.9985 11.784C13.118 11.3095 13.3071 10.8552 13.5595 10.436L12.4885 9.06402C12.4132 8.96711 12.3762 8.84589 12.3845 8.72344C12.3928 8.601 12.4458 8.48589 12.5335 8.40002L13.2335 7.70002C13.3196 7.614 13.4342 7.56238 13.5557 7.55483C13.6772 7.54728 13.7973 7.58433 13.8935 7.65902L15.2735 8.72602C15.6927 8.4736 16.1469 8.28455 16.6215 8.16502L16.8335 6.43802C16.8487 6.31643 16.908 6.20465 17.0002 6.1239C17.0923 6.04316 17.2109 5.99907 17.3335 6.00002H18.3335C18.456 5.99907 18.5746 6.04316 18.6668 6.1239C18.759 6.20465 18.8183 6.31643 18.8335 6.43802L19.0495 8.16502C19.524 8.28455 19.9783 8.4736 20.3975 8.72602L21.7735 7.65502C21.8696 7.58033 21.9897 7.54328 22.1112 7.55083C22.2327 7.55838 22.3473 7.61 22.4335 7.69602L23.1335 8.40002C23.2195 8.48618 23.2711 8.60076 23.2787 8.72227C23.2862 8.84379 23.2492 8.96388 23.1745 9.06002L22.1075 10.44C22.3599 10.8592 22.5489 11.3135 22.6685 11.788L24.3955 12C24.5171 12.0152 24.6289 12.0745 24.7096 12.1667C24.7903 12.2589 24.8344 12.3775 24.8335 12.5V13.5Z"
                    fill="#252c33"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_901_9842">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.833496)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <h6 className="text-sm sm:text-md mt-2">Job Placement</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionCall;
